export const SGA_SPEND_BINDING_PLACEHOLDER_BY_LEVER = {
  professional_fees: 'professional_fees_opportunity_usd',
  outside_contractors: 'outside_contractors_opportunity_usd',
  indirect_procurement: 'indirect_procurement_opportunity_usd',
  travel_and_expense: 'travel_and_expense_opportunity_usd',
  shared_services: 'shared_services_opportunity_usd',
  tech_software: 'tech_software_opportunity_usd',
  real_estate_footprint: 'real_estate_footprint_opportunity_usd',
  marketing_spend: 'marketing_spend_opportunity_usd',
} as const;

export type SgaSpendBindingPlaceholder =
  (typeof SGA_SPEND_BINDING_PLACEHOLDER_BY_LEVER)[keyof typeof SGA_SPEND_BINDING_PLACEHOLDER_BY_LEVER];
